/**
 * Column Helper Utilities for TanStack Table Integration
 * Handles state synchronization between parent component and TanStack Table
 */

/**
 * Convert parent sorting format to TanStack sorting format
 * Parent uses: filterKey (string|array), sortOrder ('ascend'|'descend')
 * TanStack uses: array of {id: string, desc: boolean}
 */
export const convertToTanStackSorting = (filterKey, sortOrder) => {
  if (!filterKey || !sortOrder) return [];

  // Handle array (multi-column sort)
  if (Array.isArray(filterKey)) {
    return filterKey.map((key, idx) => ({
      id: key,
      desc: sortOrder[idx] === 'descend'
    }));
  }

  // Handle single column sort
  return [{ id: filterKey, desc: sortOrder === 'descend' }];
};

/**
 * Convert TanStack sorting format to parent sorting format
 * TanStack uses: array of {id: string, desc: boolean}
 * Parent uses: filterKey (string|array), sortOrder ('ascend'|'descend')
 */
export const convertToParentSorting = sortingState => {
  if (!sortingState || sortingState.length === 0) {
    return { filterKey: [], sortOrder: [] };
  }

  // Single column sort
  if (sortingState.length === 1) {
    return {
      filterKey: sortingState[0].id,
      sortOrder: sortingState[0].desc ? 'descend' : 'ascend'
    };
  }

  // Multi-column sort
  return {
    filterKey: sortingState.map(s => s.id),
    sortOrder: sortingState.map(s => (s.desc ? 'descend' : 'ascend'))
  };
};

/**
 * Get ARIA sort attribute value for accessibility
 */
export const getAriaSortValue = sorted => {
  if (!sorted) return 'none';
  return sorted === 'desc' ? 'descending' : 'ascending';
};

/**
 * Format column widths from TanStack to simple object
 */
export const formatColumnWidths = columnSizing => {
  return Object.entries(columnSizing).reduce((acc, [key, value]) => {
    acc[key] = value;
    return acc;
  }, {});
};

/**
 * Get selected row IDs from TanStack row selection state
 */
export const getSelectedRowIds = rowSelection => {
  return Object.keys(rowSelection).filter(key => rowSelection[key]);
};
